"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tag = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _typography = require("@creditas/typography");

var _tokens = _interopRequireDefault(require("@creditas/tokens"));

var _components = require("./components");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  label: _propTypes.string,
  variant: _propTypes.string,
  size: (0, _propTypes.oneOf)(['small', 'medium', 'large'])
} : {};
const defaultProps = {
  size: 'medium',
  component: 'div',
  variant: 'neutral'
};
const colorVariants = {
  neutral: _tokens.default.bColorneutral06,
  danger: _tokens.default.bColordanger,
  warning: _tokens.default.bColorwarning,
  info: _tokens.default.bColorinfo,
  success: _tokens.default.bColorsuccess
};

const Tag = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  const {
    component,
    className,
    variant,
    size,
    label,
    ...other
  } = props;
  const color = colorVariants[variant];
  return (0, _core.jsx)(_components.Tag, (0, _extends2.default)({
    as: component,
    ref: ref,
    className: className,
    color: color,
    size: size
  }, other), (0, _core.jsx)("span", null), label && label !== '' && (0, _core.jsx)(_typography.Typography, {
    variant: "support"
  }, label));
});

exports.Tag = Tag;
process.env.NODE_ENV !== "production" ? Tag.propTypes = propTypes : void 0;
Tag.defaultProps = defaultProps;